import React, { useEffect, useState } from 'react';
import './dark-mode.css';

const DarkModeToggle = () => {
  const [darkMode, setDarkMode] = useState(false);

  // 检查用户系统偏好
  useEffect(() => {
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    setDarkMode(prefersDarkMode);
    if (prefersDarkMode) {
      document.body.classList.add('dark-mode');
    }
  }, []);

  // 切换暗黑模式
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  };

  return (
    <div className="dark-mode-toggle">
      <button 
        onClick={toggleDarkMode}
        className={`theme-toggle ${darkMode ? 'dark' : 'light'}`}
        aria-label={darkMode ? '切换到亮色模式' : '切换到暗色模式'}
      >
        {darkMode ? '🌞' : '🌙'}
      </button>
    </div>
  );
};

export default DarkModeToggle;